export function preventEvDefault() {
  return function decorate(target, key, descriptor) {
    const origFn = descriptor.value;
    // eslint-disable-next-line no-param-reassign
    descriptor.value = async function decorated(ev, ...args) {
      ev.preventDefault();
      await origFn.call(this, ev, ...args);
    };
    return descriptor;
  };
}
